export default {"src":"/_next/static/media/download-icon.475cc763.svg","height":123,"width":105,"blurWidth":0,"blurHeight":0};